export const COLORS = [
  '#55a01a',
  '#9932cc',
  '#ff69b4',
  '#6495ed',
  '#ffd700',
  '#f6a7a1',
  '#7fb397',
  '#009999',
];

export const DETECTOR_COLORS = [
  '#AEDBFC',
  '#D5BBF4',
  '#CBECA9',
  '#F5BDD8',
  '#F4B4AF',
  '#FBE59B',
  '#F5BE9C',
];

export const MEDIA_EVENTS = [
  'abort',
  'canplay',
  'canplaythrough',
  'durationchange',
  'emptied',
  'ended',
  'error',
  'loadeddata',
  'loadedmetadata',
  'loadstart',
  'pause',
  'play',
  'playing',
  'progress',
  'ratechange',
  'seeked',
  'seeking',
  'stalled',
  'suspend',
  'timeupdate',
  'volumechange',
  'waiting',
  'speedchange'
];

export const MEDIA_PROPERTIES = [
  'audioTracks',
  'autoplay',
  'buffered',
  'controller',
  'controls',
  'crossOrigin',
  'currentSrc',
  'currentTime',
  'defaultMuted',
  'defaultPlaybackRate',
  'duration',
  'ended',
  'error',
  'loop',
  'mediaGroup',
  'muted',
  'networkState',
  'paused',
  'playbackRate',
  'played',
  'preload',
  'readyState',
  'seekable',
  'seeking',
  'src',
  'startDate',
  'textTracks',
  'videoTracks',
  'volume',
  'playbackRate'
];

export const KEYWORDS_TAB = 1;
export const DETECTION_TAB = 2;
export const CLASSIFIER_TAB = 3;
export const GROUPS_TAB = 4;
